import { ChangeEvent } from 'react';
import { filter } from '../../../pages/fleet-calculator/copy';
import useSettingsStore from '../store/settings-store';
import { Mileage } from '../types';

const MILEAGE_STEPS = [1500, 2000, 3000, 4000];

const MileageFilter = () => {
  const { mileage, workMileage, updateSettingsStore } = useSettingsStore();

  const handleUpdateMileage = (e: ChangeEvent<HTMLInputElement>) => {
    const index = parseInt(e.target.value);
    const mileageValue = MILEAGE_STEPS[index] as Mileage;
    if (mileageValue < workMileage) {
      updateSettingsStore({ workMileage: mileageValue });
    }
    updateSettingsStore({ mileage: mileageValue });
  };

  const handleUpdateWorkMileage = (e: ChangeEvent<HTMLInputElement>) => {
    updateSettingsStore({ workMileage: parseInt(e.target.value) });
  };
  const currentMileageIndex = MILEAGE_STEPS.indexOf(mileage);
  return (
    <>
      <div className="flex flex-col gap-2">
        <div className="flex gap-2 justify-between">
          <label htmlFor="mileage">{filter.mileageLabel}</label>
          <p>{mileage} mil/år</p>
        </div>
        <input
          onChange={handleUpdateMileage}
          type="range"
          id="mileage"
          className="ring-dark-blue ring-offset-1 focus-visible:ring-2 transition-shadow"
          value={currentMileageIndex > -1 ? currentMileageIndex : 0}
          min={0}
          max={MILEAGE_STEPS.length - 1}
          step={1}
        />
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex gap-2 justify-between">
          <label htmlFor="business-mileage">{filter.mileageServiceLabel}</label>
          <p>{workMileage} mil/år</p>
        </div>
        <input
          onChange={handleUpdateWorkMileage}
          type="range"
          id="business-mileage"
          className="ring-dark-blue ring-offset-1 focus-visible:ring-2 transition-shadow"
          value={workMileage}
          min={100}
          max={mileage}
          step={100}
        />
      </div>
    </>
  );
};

export default MileageFilter;
